import { message } from 'antd';
import axios from 'axios';

// Action Types
export const CONTACT_FORM_CREATE_REQUEST = 'CONTACT_FORM_CREATE_REQUEST';
export const CONTACT_FORM_CREATE_SUCCESS = 'CONTACT_FORM_CREATE_SUCCESS';
export const CONTACT_FORM_CREATE_FAIL = 'CONTACT_FORM_CREATE_FAIL';

export const CONTACT_FORM_LIST_REQUEST = 'CONTACT_FORM_LIST_REQUEST';
export const CONTACT_FORM_LIST_SUCCESS = 'CONTACT_FORM_LIST_SUCCESS';
export const CONTACT_FORM_LIST_FAIL = 'CONTACT_FORM_LIST_FAIL';

export const CONTACT_FORM_DELETE_REQUEST = 'CONTACT_FORM_DELETE_REQUEST';
export const CONTACT_FORM_DELETE_SUCCESS = 'CONTACT_FORM_DELETE_SUCCESS';
export const CONTACT_FORM_DELETE_FAIL = 'CONTACT_FORM_DELETE_FAIL';

export const CONTACT_FORM_DELETE_ALL_REQUEST = 'CONTACT_FORM_DELETE_ALL_REQUEST';
export const CONTACT_FORM_DELETE_ALL_SUCCESS = 'CONTACT_FORM_DELETE_ALL_SUCCESS';
export const CONTACT_FORM_DELETE_ALL_FAIL = 'CONTACT_FORM_DELETE_ALL_FAIL';

const API_URL = `${process.env.REACT_APP_API_URL}/contactForm`;
// Action Creators
export const createContactForm = (paylod: any) => async (dispatch: any) => {
    try {
        dispatch({ type: CONTACT_FORM_CREATE_REQUEST });

        const { data } = await axios.post(`${API_URL}`, paylod);

        dispatch({
            type: CONTACT_FORM_CREATE_SUCCESS,
            payload: data
        });
        message.success('İletişim formu kaydı başarıyla oluşturuldu');
    } catch (error: any) {
        dispatch({
            type: CONTACT_FORM_CREATE_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
        throw error;
    }
};

    export const listContactForms = () => async (dispatch) => {
    try {
        dispatch({ type: CONTACT_FORM_LIST_REQUEST });

        const response = await axios.get(`${API_URL}`);

        dispatch({
            type: CONTACT_FORM_LIST_SUCCESS,
            payload: response.data
        });
    } catch (error: any) {
        dispatch({
            type: CONTACT_FORM_LIST_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
    }
};

export const deleteContactForm = (id) => async (dispatch) => {
    try {
        dispatch({ type: CONTACT_FORM_DELETE_REQUEST });

        await axios.delete(`${API_URL}/${id}`);

        dispatch({
            type: CONTACT_FORM_DELETE_SUCCESS,
            payload: id
        });
    } catch (error: any) {
        dispatch({
            type: CONTACT_FORM_DELETE_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
    }
};

export const deleteAllContactForms = () => async (dispatch) => {
    try {
        dispatch({ type: CONTACT_FORM_DELETE_ALL_REQUEST });

        await axios.delete(`${API_URL}`);

        dispatch({
            type: CONTACT_FORM_DELETE_ALL_SUCCESS
        });
    } catch (error: any) {
        dispatch({
            type: CONTACT_FORM_DELETE_ALL_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
    }
}; 